<form role="form" class="form-horizontal">
	<div [class]="'form-group' + (filters.perimetreGeographique === typesPerimetresGeo.AVANCE ? ' reduce-bottom-margin' : '')">
		<label for="perimtereGeo" class="col-md-1 plus-half control-label">P&eacute;rim&egrave;tre g&eacute;ographique&nbsp;:</label>
		<div class="col-sm-10 plus-half">
			<label class="radio-inline" *ngFor="let type of typePerimetreOptions">
				<input type="radio"
					name="perimtereGeo"
					[id]="'perimtereGeo_' + type"
					[value]="type"
					[(ngModel)]="filters.perimetreGeographique"
				>
				{{ typePerimetreLabels[type] }}
			</label>
		</div>
	</div>
	
	<fieldset *ngIf="filters.perimetreGeographique === typesPerimetresGeo.AVANCE"
		class="perimetre"
		>
		<legend>Filtres g&eacute;ographiques avanc&eacute;s</legend>
		<filtre-geographique
			[labelClass]="'col-md-1'"
			[shortFieldClass]="'col-md-6'"
			[longFieldClass]="'col-md-11'"
			[resetCommands]="resetCommands"
			(agenceIdChange)="filters.agenceId = $event"
			(antenneIdsChange)="filters.antenneIdsSelection = $event"
			(parcIdsChange)="filters.parcIdsSelection = $event"
			(sousParcIdsChange)="filters.sousParcsIdsSelection = $event"
			(ouvrageIdsChange)="filters.ouvrageIdsSelection = $event"
			>
		</filtre-geographique>
	</fieldset>

	<div class="form-group">
		<parc-maintenance-checkbox-list
			[id]="'choixMaintenance'"
			[labelClass]="'col-md-1 plus-half'"
			[fieldClass]="'col-md-4 plus-half'"
			[resetCommands]="resetCommands"
			(selectionIdsChange)="filters.parcMaintenanceIdsSelection = $event"
			>
		</parc-maintenance-checkbox-list>
		<parc-technologie-checkbox-list
			[id]="'choixTechnologie'"
			[labelClass]="'col-md-1 plus-half'"
			[fieldClass]="'col-md-4 plus-half'"
			[resetCommands]="resetCommands"
			(selectionIdsChange)="filters.parcTechnologieIdsSelection = $event"
			>
		</parc-technologie-checkbox-list>
	</div>
	
	<div class="form-group">
		<memo-category-checkbox-list
			[id]="'choixCategorie'"
			[label]="'M&eacute;mo'"
			[wildcardOptionLabel]="'Tous'"
			[labelClass]="'col-md-1 plus-half'"
			[fieldClass]="'col-md-4 plus-half'"
			[resetCommands]="resetCommands"
			(selectionIdsChange)="filters.memoCategoryIdsSelection = $event"
			>
		</memo-category-checkbox-list>
		<label for="choixStatus" class="control-label col-md-1 plus-half">Statut Mémo</label>
		<div class="col-md-4 plus-half">
			<checkbox-list
				[id]="'choixStatus'"
				[wildcardOptionLabel]="'Tous'"
				[itemList]="statutMemoOptions"
				[labelGetter]="getStatutsMemoLabel"
				[preselectionFunction]="statutShouldBeSelectedByDefaut"
				[resetCommands]="resetCommands"
				(selectedItemsChange) = "onMemoStatusSelection($event)"
				>
			</checkbox-list>
		</div>
	</div>
	<div class="form-group">
		<div class="col-sm-6 text-center">
			<button type="button" class="btn btn-success" (click)="search()">Filtrer</button>
		</div>
		<div class="col-sm-6 text-center">
			<button type="button" class="btn btn-primary" (click)="resetFilters()">R&eacute;initialiser</button>
		</div>
	</div>
</form>